/**
 * Get health status color based on score thresholds
 * Green (70%+), Yellow (50-69%), Red (<50%)
 */
export const getHealthStatusColor = (healthScore: number): string => {
	if (healthScore >= 70) return "#22c55e"; // Green
	if (healthScore >= 50) return "#eab308"; // Yellow
	return "#ef4444"; // Red
};

export const getMarkerColor = (healthScore: number): string => {
	if (healthScore >= 90) return "#8A2E8F"; // Brand Purple
	if (healthScore >= 80) return "#954580"; // Medium Purple
	if (healthScore >= 70) return "#732B5C"; // Dark Purple
	if (healthScore >= 60) return "#C84249"; // Deep Red-Pink
	return "#AC2C2B"; // Brand Red
};

export const getMarkerSVG = (healthScore: number): string => {
	const color = getMarkerColor(healthScore);
	const borderColor = getHealthStatusColor(healthScore);
	return `
        <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14" cy="14" r="11" fill="${color}"/>
            <circle cx="14" cy="14" r="12.5" fill="none" stroke="${borderColor}" stroke-width="2.5"/>
        </svg>
    `;
};

export const getClusterSVG = (
	count: number,
	avgHealthScore: number,
): string => {
	const color = getMarkerColor(avgHealthScore);
	const borderColor = getHealthStatusColor(avgHealthScore);
	return `
        <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <filter id="clusterFog">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
                    <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0.25 0"/>
                </filter>
            </defs>
            <circle cx="30" cy="30" r="25" fill="${color}" filter="url(#clusterFog)"/>
            <circle cx="30" cy="30" r="20" fill="${color}" opacity="0.6"/>
            <circle cx="30" cy="30" r="15" fill="${color}" opacity="0.9"/>
            <circle cx="30" cy="30" r="17" fill="none" stroke="${borderColor}" stroke-width="2.5" opacity="0.9"/>
            <text x="30" y="32" 
                  font-family="Arial" 
                  font-size="15" 
                  fill="#FFFFFF" 
                  text-anchor="middle" 
                  dominant-baseline="middle"
                  font-weight="bold">
                ${count}
            </text>
        </svg>
    `;
};
